import { BeMappedNode } from "src/constants/NodeDataTypes";
import { NODE_TYPE } from "src/constants/NodeTypes";

export const hasNodeAccessedFields = (node: BeMappedNode) => {
  return ![NODE_TYPE.OUTPUT_NODE, NODE_TYPE.INPUT_NODE].includes(node.type);
};
